import { DateTime } from "luxon";
import { ArvidMetadata } from "./metadata/Arvid";
import { DomsdatabasenMetadata } from "./metadata/Domsdatabasen";
import { RetsinformationMetadata } from "./metadata/Retsinformation";
import { EurLexMetadata } from "./metadata/EURLex";
import { TableOfContentsItem } from "@/models/table-of-contents";

export enum LegislationStatus {
  Valid = "Valid",
  Historic = "Historic",
  Active = "Active",
}
export const legislationStatusToDanish: Record<LegislationStatus, string> = {
  [LegislationStatus.Valid]: "Gældende",
  [LegislationStatus.Historic]: "Historisk",
  [LegislationStatus.Active]: "Underskrevet",
};

export type Legislation = {
  internalId: string;
  externalId: string;
  title: string;
  datasource: string;
  metadataObject?: string;
  metadata: LegislationMetadata;
  html?: string;
  htmlWithIds?: string;
  processedAt?: DateTime;
  version?: number;
  latestVersion?: boolean;
  pdfUrls?: string[];
  htmlAvailable?: boolean;
  htmlProcessingIncomplete?: boolean;
  publishedOn?: string | null;
  isCurrent?: boolean | null;
  legislationExternalId?: string | null;
  downloadLink?: string | null;
  tableOfContentsGold?: TableOfContentsItem[] | null;
  /** Consolidation window metadata from silver (inbound/outbound changes). */
  consolidationMetadata?: string | Record<string, unknown> | null;
  /** Ændringslove on the timeline after this Lov/LBK row (from API). */
  timelineAmendmentCountAfter?: number;
};

export enum DocumentCategory {
  Workspace = "Workspace",
  Legislation = "Legislation",
  LegislationReference = "LegislationReference",
  Document = "Document",
}

export type LegislationMetadata =
  | ArvidMetadata
  | DomsdatabasenMetadata
  | EurLexMetadata
  | RetsinformationMetadata
  | null;
